export default __webpack_public_path__ + "static/media/analista.02b27474.png";